export const isApac:boolean = process.env.REACT_APP_REGION === 'apac'
export const isLocal:boolean = process.env.REACT_APP_ENVIRONMENT==='local';
